import { render } from "./TableFerramentaUnicaVale.vue?vue&type=template&id=3e57bedc&scoped=true"
import script from "./TableFerramentaUnicaVale.vue?vue&type=script&lang=js"
export * from "./TableFerramentaUnicaVale.vue?vue&type=script&lang=js"

import "./TableFerramentaUnicaVale.vue?vue&type=style&index=0&id=3e57bedc&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e57bedc"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QPagination});
